import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { get } from "../helper/helper_api";
import { toast } from "react-toastify";

function Sidebar(props) {

  const { setLoading } = props;
  const [data, setData] = useState(undefined);
  const [news, setNews] = useState(undefined);

  useEffect(() => {
    if (setLoading)
      setLoading(true);
    get("/news")
      .then((res) => {
        console.log("News Panel res", res);
        if (setLoading)
          setLoading(false);
        if (res?.statusCode == 200) {
          setData(res?.data);
          setNews(res?.news);
        } else
          toast.error(res?.error)
      })
      .catch((error) => {
        console.log("error", error);
        if (setLoading)
          setLoading(false);
      });
  }, []);

  return (
    <div className="left-sidebar">
      <div className="panel-group panel_group_new" id="accordion1">
        <div className="panel panel-default">
          <div className="panel-heading">
            <h4 className="panel-title " id="headingOne">
              <h4
                style={{
                  color: "#b70f0f",
                  fontWeight: "bold",
                  fontSize: "13px",
                }}
                className="accordion-button"
                type="button"
                data-bs-toggle="collapse"
                data-bs-target="#collapseOne"
                aria-expanded="true"
                aria-controls="collapseOne"
              >
                NEWS & UPDATE
              </h4>
            </h4>
          </div>
          <div
            id="SOP"
            className="panel-collapse collapse Purchase"
            aria-labelledby="headingOne"
            data-bs-parent="#accordion1"
          ></div>

          <div className="accordion-body mymove1">
            {/* <ul>
                <div className="mymove">
                  {data &&
                    data.map((item, index) => (
                      <li key={index}>
                        <Link to={item.pdfUrl}>
                          {" "}
                          <img src="images/arrow.png" alt="" />
                          {item.title}{" "}
                        </Link>
                      </li>
                    ))}
                </div>
              </ul> */}
            <ul>
              <div className="mymove">
                {data &&
                  data.map((item, index) => (
                    <li key={index}>
                      <a
                        href={item.pdf}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <img src="images/arrow.png" alt="" />
                        {item.title}
                      </a>
                    </li>
                  ))}
                {news &&
                  news.map((item, index) => (
                    <li key={index}>
                      <a
                        href={item.link}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <img src="images/arrow.png" alt="" />
                        {item.name}
                      </a>
                    </li>
                  ))}
              </div>
            </ul>
          </div>

        </div>
      </div>

      <div className="line"></div>
      <div className="panel-group" id="accordion1">
        <div className="panel panel-default">
          <div className="accordion" id="accordionExample">
            {/* <div className="accordion-item">
              <h4 className="panel-title " id="headingOne">
                <h4
                  style={{ color: "#b70f0f", fontWeight: "bold" }}
                  className="accordion-button"
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target="#collapseOne"
                  aria-expanded="false"
                  aria-controls="collapseOne"
                >
                  SOP
                </h4>
              </h4>
              <div
                id="collapseOne"
                className="accordion-collapse collapse show"
                aria-labelledby="headingOne"
                data-bs-parent="#accordionExample"
              >
                <div className="item-seven accordion-body">
                  <ul>
                    <li style={{ borderBottom: "solid #e4dada 1px" }}>
                      <a
                        href="pdf/Standard Operating Procedure  (SOP).pdf"
                        target="_blank"
                      >
                        {" "}
                        <img src="images/arrow.png" alt="" />
                        Standard Operating Procedure(SOP) for implementation of
                        OTS and for Discharging various other
                        liabilities(28.08.2023).
                      </a>
                    </li>
                    <li style={{ borderBottom: "solid #e4dada 1px" }}>
                      <a href="pdf/SOP Dated 21.03.2023.pdf" target="_blank">
                        <img src="images/arrow.png" alt="" />
                        Standard Operating Procedure(SOP) for implementation of
                        OTS and for Discharging various other
                        liabilities(21.03.2023).
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
              
            </div> */}
            <div>
              <div className="accordion-item">
                <h4 className="panel-title " id="headingOne">
                  <h4
                    style={{ color: "#b70f0f", fontWeight: "bold" }}
                    className="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#collapseOne"
                    aria-expanded="false"
                    aria-controls="collapseOne"
                  >
                    SOP
                  </h4>
                </h4>
                <div
                  id="collapseOne"
                  className="accordion-collapse collapse"
                  aria-labelledby="headingOne"
                  data-bs-parent="#accordionExample"
                >
                  <div className="item-seven accordion-body">
                    <ul>
                      <li style={{ borderBottom: "solid #e4dada 1px" }}>
                        <a
                          href="pdf/Standard Operating Procedure  (SOP).pdf"
                          target="_blank"
                        >
                          {" "}
                          <img src="images/arrow.png" alt="" />
                          Standard Operating Procedure(SOP) for implementation
                          of OTS and for Discharging various other
                          liabilities(28.08.2023).
                        </a>
                      </li>
                      <li style={{ borderBottom: "solid #e4dada 1px" }}>
                        <a href="pdf/SOP Dated 21.03.2023.pdf" target="_blank">
                          <img src="images/arrow.png" alt="" />
                          Standard Operating Procedure(SOP) for implementation
                          of OTS and for Discharging various other
                          liabilities(21.03.2023).
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
            {/* <div className="line"></div> */}
            <div className="accordion-item">
              <h4 className="accordion-header" id="headingTwo">
                <h4
                  style={{ color: "#b70f0f", fontWeight: "bold" }}
                  className="accordion-button collapsed"
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target="#collapseTwo"
                  aria-expanded="false"
                  aria-controls="collapseTwo"
                >
                  Finance Desk
                </h4>
              </h4>
              <div
                id="collapseTwo"
                className="accordion-collapse collapse"
                aria-labelledby="headingTwo"
                data-bs-parent="#accordionExample"
              >
                <div className="item-seven accordion-body">
                  <div className="panel-group" id="accordion1">
                    <div className="panel panel-default">
                      <div className="accordion" id="accordionExample1">
                        <div className="accordion-item">
                          <h4 className="accordion-header" id="headingEight">
                            <h4
                              // style={{ color: "#b70f0f", fontWeight: "bold" }}
                              className="accordion-button collapsed"
                              type="button"
                              data-bs-toggle="collapse"
                              data-bs-target="#collapseEight"
                              aria-expanded="false"
                              aria-controls="collapseEight"
                            >
                              Annual Report for the Year 2014-15
                            </h4>
                          </h4>
                          <div
                            id="collapseEight"
                            className="accordion-collapse collapse"
                            aria-labelledby="headingSeven"
                            data-bs-parent="#accordionExample1"
                          >
                            <div className=" item-seven accordion-body">
                              <ul>
                                <li
                                  style={{ borderBottom: "solid #e4dada 1px" }}
                                >
                                  <a
                                    href="../pdf/Director's-Report.pdf"
                                    target="_blank"
                                  >
                                    {" "}
                                    1. Director's Report{" "}
                                  </a>
                                </li>
                                <li
                                  style={{ borderBottom: "solid #e4dada 1px" }}
                                >
                                  <a
                                    href="../pdf/ADDENDUM-14-15-FULL.pdf"
                                    target="_blank"
                                  >
                                    {" "}
                                    2. ADDENDUM 14-15{" "}
                                  </a>
                                </li>
                                <li
                                  style={{ borderBottom: "solid #e4dada 1px" }}
                                >
                                  <a
                                    href="../pdf/Comments-of-the-Comptroller-and-Auditor-General.pdf"
                                    target="_blank"
                                  >
                                    {" "}
                                    3. Comments of the Comptroller and Auditor
                                    General{" "}
                                  </a>
                                </li>
                                <li
                                  style={{ borderBottom: "solid #e4dada 1px" }}
                                >
                                  <a
                                    href="../pdf/Auditor's-Report.pdf"
                                    target="_blank"
                                  >
                                    {" "}
                                    4. Auditor's Report{" "}
                                  </a>
                                </li>
                                <li
                                  style={{ borderBottom: "solid #e4dada 1px" }}
                                >
                                  <a
                                    href="../pdf/Statement-of-Accounts.pdf"
                                    target="_blank"
                                  >
                                    {" "}
                                    5. Statement of Accounts{" "}
                                  </a>
                                </li>
                                <li
                                  style={{ borderBottom: "solid #e4dada 1px" }}
                                >
                                  <a
                                    href="../pdf/Significant-Accounting-Policies.pdf"
                                    target="_blank"
                                  >
                                    {" "}
                                    6. Significant Accounting Policies{" "}
                                  </a>
                                </li>
                              </ul>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    id="livingroom-jit"
                    className="panel-collapse collapse Purchase"
                    style={{ height: "0px;" }}
                  >
                    <ul
                      style={{
                        marginLeft: "20px",
                        listStyleImage: "none",
                        listStyleType: "decimal !important",
                      }}
                    >
                      <li>
                        {" "}
                        <a href="../pdf/Director's-Report.pdf" target="_blank">
                          {" "}
                          Director's Report{" "}
                        </a>
                      </li>
                      <li>
                        {" "}
                        <a
                          href="../pdf/ADDENDUM-14-15-FULL.pdf"
                          target="_blank"
                        >
                          {" "}
                          ADDENDUM 14-15{" "}
                        </a>
                      </li>
                      <li>
                        {" "}
                        <a
                          href="../pdf/Comments-of-the-Comptroller-and-Auditor-General.pdf"
                          target="_blank"
                        >
                          {" "}
                          Comments of the Comptroller and Auditor General{" "}
                        </a>
                      </li>
                      <li>
                        {" "}
                        <a href="../pdf/Auditor's-Report.pdf" target="_blank">
                          {" "}
                          Auditor's Report{" "}
                        </a>
                      </li>
                      <li>
                        {" "}
                        <a
                          href="../pdf/Statement-of-Accounts.pdf"
                          target="_blank"
                        >
                          {" "}
                          Statement of Accounts{" "}
                        </a>
                      </li>
                      <li>
                        {" "}
                        <a
                          href="../pdf/Significant-Accounting-Policies.pdf"
                          target="_blank"
                        >
                          {" "}
                          Significant Accounting Policies{" "}
                        </a>
                      </li>
                    </ul>
                  </div>
                  <ul>
                    <li style={{ borderBottom: "solid #e4dada 1px" }}>
                      <a
                        href="../pdf/55th-AR-2015-16-English.pdf"
                        target="_blank"
                      >
                        {" "}
                        <img src="images/arrow.png" alt="" />
                        Annual Report for the Year 2015-16{" "}
                      </a>
                    </li>
                    <li style={{ borderBottom: "solid #e4dada 1px" }}>
                      <a
                        href="../pdf/Statement-of-accounts-fy-2016-17.pdf"
                        target="_blank"
                      >
                        {" "}
                        <img src="images/arrow.png" alt="" />
                        Statement of Accounts FY 2016-17{" "}
                      </a>
                    </li>
                    <li style={{ borderBottom: "solid #e4dada 1px" }}>
                      <a
                        href="../pdf/57th-Annual-Report-2017-18.pdf"
                        target="_blank"
                      >
                        {" "}
                        <img src="images/arrow.png" alt="" />
                        Annual Report for the FY 2017-18{" "}
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            {/* <div className="line"></div> */}
            <div className="accordion-item">
              <h4 className="accordion-header" id="headingThree">
                <h4
                  style={{ color: "#b70f0f", fontWeight: "bold" }}
                  className="accordion-button collapsed"
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target="#collapseThree"
                  aria-expanded="false"
                  aria-controls="collapseThree"
                >
                  EPFO
                </h4>
              </h4>
              <div
                id="collapseThree"
                className="accordion-collapse collapse"
                aria-labelledby="headingThree"
                data-bs-parent="#accordionExample"
              >
                <div className=" item-seven accordion-body">
                  <ul>
                    <li style={{ borderBottom: "solid #e4dada 1px" }}>
                      <a
                        href="../pdf/EPFO/HigherPensionNewpdf.pdf"
                        target="_blank"
                      >
                        <img src="images/arrow.png" alt="" />
                        Circular regarding EPFO clarification
                      </a>
                    </li>
                    <li style={{ borderBottom: "solid #e4dada 1px" }}>
                      <a
                        href="../pdf/EPFO/EPFO-Circular-for-Higher_Pension_20022023.pdf"
                        target="_blank"
                      >
                        <img src="images/arrow.png" alt="" />
                        EPFO Circular No. Pension/2022/56259/16541{" "}
                      </a>
                    </li>
                    <li style={{ borderBottom: "solid #e4dada 1px" }}>
                      <a
                        href="../pdf/EPFO/Extention-of-date-for-Higher-Pension.pdf"
                        target="_blank"
                      >
                        <img src="images/arrow.png" alt="" />
                        Extention of date for Higher Pension{" "}
                      </a>
                    </li>
                    <li style={{ borderBottom: "solid #e4dada 1px" }}>
                      <a
                        href="../pdf/EPFO/EPFO-Extented-for-validation-of-joint-option.pdf"
                        target="_blank"
                      >
                        <img src="images/arrow.png" alt="" />
                        Pension on Higher wages{" "}
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            {/* <div className="line"></div> */}
            <div className="accordion-item">
              <div className="accordion-header" id="headingFour">
                <h4
                  style={{ color: "#b70f0f", fontWeight: "bold" }}
                  className="accordion-button collapsed"
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target="#collapseFour"
                  aria-expanded="false"
                  aria-controls="collapseFour"
                >
                  Pharmaceuticals Purchase Policy
                </h4>
              </div>
              <div
                id="collapseFour"
                className="accordion-collapse collapse"
                aria-labelledby="headingFour"
                data-bs-parent="#accordionExample"
              >
                <div className=" item-seven accordion-body">
                  <ul>
                    <li style={{ borderBottom: "solid #e4dada 1px" }}>
                      <a
                        href="../pdf/PPP Order/PPP Price List  07-Aug-2006/PPP OM.pdf"
                        target="_blank"
                      >
                        <img src="images/arrow.png" alt="" />
                        PPP OM 2006{" "}
                      </a>
                    </li>
                    <li style={{ borderBottom: "solid #e4dada 1px" }}>
                      <a
                        href="../pdf/PPP Order/PPP Price List  07-Aug-2006/PPP Prices- NPPA Approved 07.08.2006.pdf"
                        target="_blank"
                      >
                        <img src="images/arrow.png" alt="" />
                        PPP Price List 07-Aug-2006{" "}
                      </a>
                    </li>
                    <li style={{ borderBottom: "solid #e4dada 1px" }}>
                      <a
                        href="../pdf/PPP Order/PPP Price List  31-Dec-2008/NPPA approved  PPP Price List 31.12.08.pdf"
                        target="_blank"
                      >
                        <img src="images/arrow.png" alt="" />
                        PPP Price List 31-Dec-2008
                      </a>
                    </li>
                    <li style={{ borderBottom: "solid #e4dada 1px" }}>
                      <a
                        href="../pdf/PPP Order/PPP Price list  13-Jan-2013/PPP Price List 2013.pdf"
                        target="_blank"
                      >
                        <img src="images/arrow.png" alt="" />
                        PPP Price list 13-Jan-2013
                      </a>
                    </li>
                    <li style={{ borderBottom: "solid #e4dada 1px" }}>
                      <a
                        href="../pdf/PPP Order/PPP Price list  13-Feb-2014/New PPP list 13.02.2014.pdf"
                        target="_blank"
                      >
                        '<img src="images/arrow.png" alt="" />
                        PPP Price list 13-Feb-2014
                      </a>
                    </li>
                    <li style={{ borderBottom: "solid #e4dada 1px" }}>
                      <a
                        href="../pdf/PPP Order/PPP Price List  09-Jun-2015/PPP List.pdf"
                        target="_blank"
                      >
                        <img src="images/arrow.png" alt="" />
                        PPP Price List 09-Jun-2015
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            {/* <div className="line"></div> */}
            <div className="accordion-item">
              <h4 className="accordion-header" id="headingFive">
                <h4
                  style={{ color: "#b70f0f", fontWeight: "bold" }}
                  className="accordion-button collapsed"
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target="#collapseFive"
                  aria-expanded="false"
                  aria-controls="collapseFive"
                >
                  Rate Contract
                </h4>
              </h4>
              <div
                id="collapseFive"
                className="accordion-collapse collapse"
                aria-labelledby="headingFive"
                data-bs-parent="#accordionExample"
              >
                <div className="item-seven accordion-body">
                  <ul>
                    <li style={{ borderBottom: "solid #e4dada 1px" }}>
                      <a href="../pdf/DGS&D RATE CONTRACT.pdf" target="_blank">
                        <img src="images/arrow.png" alt="" />
                        DGS & D Rate Contract
                      </a>
                    </li>
                    <li style={{ borderBottom: "solid #e4dada 1px" }}>
                      <a href="../pdf/idpl-gurgaon-esirc.pdf" target="_blank">
                        <img src="images/arrow.png" alt="" />
                        ESIC RC - IDPL{" "}
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            {/* <div className="line"></div> */}
            <div className="accordion-item d-none">
              <h4 className="accordion-header" id="headingSix">
                <h4
                  style={{ color: "#b70f0f", fontWeight: "bold" }}
                  className="accordion-button collapsed"
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target="#collapseSix"
                  aria-expanded="false"
                  aria-controls="collapseSix"
                >
                  RTI
                </h4>
              </h4>
              <div
                id="collapseSix"
                className="accordion-collapse collapse"
                aria-labelledby="headingSix"
                data-bs-parent="#accordionExample"
              >
                <div className="item-seven accordion-body">
                  <ul>
                    <li style={{ borderBottom: "solid #e4dada 1px" }}>
                      <a href="../pdf/rti-act.pdf" target="_blank">
                        {" "}
                        <img src="images/arrow.png" alt="" />
                        RTI Act, 2005
                      </a>
                    </li>
                    <li style={{ borderBottom: "solid #e4dada 1px" }}>
                      <a
                        href="../pdf/CPIO-&-PIO-as-on-09.04.2025.pdf"
                        target="_blank"
                      >
                        <img src="images/arrow.png" alt="" />
                        CPIO & PIO
                      </a>
                    </li>
                    <li style={{ borderBottom: "solid #e4dada 1px" }}>
                      <a
                        href="pdf/Disclosure-25.02.2025.pdf"
                        target="_blank"
                      >
                        {" "}
                        <img src="images/arrow.png" alt="" />
                        Disclosure under section 4(1)(b) of Right to Information
                        Act 2005.
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="line"></div>

      <div className="panel-group" id="accordion1">
        <div className="panel panel-default">
          <div className="accordion" id="accordionExample">
            <div className="accordion-item">
              <h4 className="accordion-header" id="headingSeven">
                <h4
                  style={{ color: "#b70f0f", fontWeight: "bold" }}
                  className="accordion-button collapsed"
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target="#collapseSeven"
                  aria-expanded="false"
                  aria-controls="collapseSeven"
                >
                  IDPL Township
                </h4>
              </h4>
              <div
                id="collapseSeven"
                className="accordion-collapse collapse"
                aria-labelledby="headingSeven"
                data-bs-parent="#accordionExample"
              >
                <div className=" item-seven accordion-body">
                  <ul>
                    <li style={{ borderBottom: "solid #e4dada 1px" }}>
                      <a href="../pdf/detail-of-quarter.pdf" target="_blank">
                        {" "}
                        <img src="images/arrow.png" alt="" />
                        Detail of Quarters
                      </a>
                    </li>
                    <li style={{ borderBottom: "solid #e4dada 1px" }}>
                      <a href="../pdf/quarter-circular.pdf" target="_blank">
                        <img src="images/arrow.png" alt="" />
                        Quarter Circular
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="line"></div>

      <div className="other">
        <h4 className="accordion-header" id="headingSeven">
          {/* <h4
            style={{
              color: "#b70f0f",
              fontWeight: "bold",
              fontSize: "12px",
            }}
            className="accordion-button collapsed"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#collapseSeven"
            aria-expanded="false"
            aria-controls="collapseSeven"
          >
            OTHER
          </h4> */}
        </h4>
        <ul>
          <li
            style={{
              color: "#b70f0f",
              fontWeight: "bold",
              fontSize: "12px",
            }}
            className="accordion-button collapsed"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#collapseSeven"
            aria-expanded="false"
            aria-controls="collapseSeven"
          >
            OTHER
          </li>
          <li
            style={{
              textAlign: "left",
            }}
          >
            <a href="../pdf/TA-&-DA-Rules.pdf" target="_blank">
              TA & DA Rules
            </a>
          </li>
          <li
            style={{
              textAlign: "left",
            }}
          >
            <Link to="/purchase-procedure">Purchase Procedure</Link>
          </li>
          <li
            style={{
              textAlign: "left",
            }}
          >
            <Link to="/tenders-archive">Archive</Link>
          </li>
          <li
            style={{
              textAlign: "left",
            }}
          >
            <Link to="/important-links">Important Links</Link>
          </li>
        </ul>
      </div>


      {/* <div className="line"></div>
      <div className="panel panel-default">
        <div className="panel-heading">
          <h4 className="panel-title" style={{ color: "#b70f0f" }}>
            SWACHH BHARAT ABHIYAN
          </h4>
        </div>
        <p style={{ margin: "7px 1px" }}>
          "A message from Minister (C & F)" "All donations towards the Prime
          Minister's National relief Fund (PMNRF) are notified for 100%
          deduction from taxable income under Section 80G of the Income Tax Act,
          1961."
        </p>
        <p
          style={{
            margin: "7px 1px",
            textAlign: "left",
          }}
        >
          <a
            href="../pdf/SwachhAbiyanMessage.pdf"
            className="readmore"
            target="_blank"
            style={{ color: "#fff", textDecoration: "none" }}
          >
            Read More
          </a>
        </p>
      </div> */}
    </div>
  );
}

export default Sidebar;
